import useLocalStorage from './useLocalStorage';

interface IAuth {
  token: string;
  refreshToken: string;
}

const useAuth = () => {
  const [storeAuth, retrieveAuth, removeAuth] = useLocalStorage<IAuth>('Auth');
  return { storeAuth, retrieveAuth, removeAuth };
};

export default useAuth;
